import { TStore } from "@redux/store.types";

import { ComponentMap } from "./@types/hydrator.types";
import renderers from "./renderers";

export default class Hydrator {
    store: TStore;
    componentMaps: Record<string, ComponentMap> = {};

    constructor(store: TStore) {
        this.store = store;
    }

    registerComponentMap(key: string, newMap: ComponentMap) {
        this.componentMaps[key] = newMap;
    }

    getComponentMap(key: string) {
        return this.componentMaps[key] || {};
    }

    rehydrateAEMComponent(dataPath: string) {
        renderers.AEM(this.store, dataPath);
    }

    rehydrateSSRComponent(dataPath: string) {
        renderers.SSR(this.store, dataPath);
    }

    rehydrate() {
        performance.mark("Hubo: Hydrator.rehydrate");
        renderers.SSR(this.store);
        renderers.AEM(this.store);
        performance.measure(
            "Hubo: Duration Hydrator.rehydrate",
            "Hubo: Hydrator.rehydrate",
        );
    }

    rehydrateModalComponent(element: HTMLElement) {
        renderers.SSRModal(this.store, element);
        renderers.AEMModal(this.store, element);
    }
}
